import './App.css';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import routesConfig from './routes';
import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from 'react';
import apiClient from './components/utils/apiClient';
import useUser from './components/helpers/useUser';
import useToken from './components/helpers/useToken';
import { ToastProvider } from './components/Toast/ToastContext';
import ToastContainer from './components/Toast/ToastContainer';
import { clarity } from 'react-microsoft-clarity';

export const UserContext = React.createContext(null);

const router = createBrowserRouter(routesConfig);

const App = () => {

  

  const [token, setToken] = useToken();
  const [user,setUser] = useUser();

  const [fields, setFields] = useState(null);
  const [mainFieldsOptions, setMainFieldsOptions] = useState([]);
  const [units, setUnits] = useState(null);
  const [unitsOptions, setUnitsOptions] = useState([]);
  const [businessPackage, setBusinessPackage] = useState(null);

  const [isUserLoggedIn, setIsUserLoggedIn] = useState(false);

  const InventoryCategoriesOptions = [
    {label:'كهرباء', value: 'electrical'},
    {label:'سباكة', value: 'plumbing'},
    {label:'ادوات تنظيف', value: 'cleaning_supplies'},
    {label:'قطع غيار تكييف', value: 'hvac_parts'},
    {label:'ادوات', value: 'tools'},
    {label:'معدات امان', value: 'safety_equipment'},
    {label:'ادوات مكتب', value: 'office_supplies'},
    {label:'أخرى', value: 'other'},
  ]

  const AssetTypeOptions = [
    {label:'تكييف وتبريد', value: 'hvac'},
    {label:'مصعد', value: 'elevator'},
    {label:'كاميرا مراقبة', value: 'cctv'},
    {label:'طفاية حريق', value: 'fire_extinguisher'},
    {label:'مضخه مياة', value: 'water_pump'},
    {label:'مولد', value: 'generator'},
    {label:'لوحة كهربائية', value: 'electrical_panel'},
    {label:'نظام السباكة', value: 'plumbing_system'},
    {label:'أخرى', value: 'other'},
  ]

  const AssetsStatusOptions = [
    {label:'يعمل', value: 'active'},
    {label:'تحت الصيانة', value: 'under_maintenance'},
    {label:'يحتاج للتغير', value: 'needs_replacement'},
    {label:'خارج الخدمة', value: 'decommissioned'},
  ]

  const getFields = async () => {
    try {
        const response = await apiClient.get(`/fields`);
        if(response?.data) {
          setFields(response?.data);
          setMainFieldsOptions(response?.data?.map(field => ({value: field?.field?.code, label: field?.field?.name?.ar})));
        }
      } catch(err) {}
  }
  const getUnits = async () => {
    if(!user) return;
    try {
        const response = await apiClient.get(`/b-units?business=${user?.business?._id ? user?.business._id : user?.business}`);
        if(response?.data) {
          setUnits(response?.data);
          setUnitsOptions(response?.data?.map(unit => ({value: unit?._id, label: unit?.name, propertyId: unit?.propertyId})));
        }
      } catch(err) {}
  }


  const getUserData = async () => {
          let url;
          if(user?.role === 'OWNER') {
              url = '/b-owners/';
          } else {
              url = '/b-users/';
          }
          try {
            const response = await apiClient.get(`${url}${user?._id}`);
            if(response?.data) {
              if(response?.data?.business?._id) {
                setBusinessPackage(response?.data?.business?.packageDetails ?? response?.data?.business?.package);
              } else {
                getBusinessDetails(response?.data);
              }
            } else {
    
            }
          } catch(err) {}
        }

        const getBusinessDetails = async (user) => {
        try {
          const response = await apiClient.get(`/b-business/${user?.business}`);
          if(response?.data) {
            setBusinessPackage(response?.data?.packageDetails || response?.data?.package);
          } else {
  
          }
        } catch(err) {
        }
    }
  
      useEffect(()=>{
          if(user && user?._id && user?.role) {
              getUserData();
          }
      },[user])

      useEffect(()=>{
        if(isUserLoggedIn) {
          setUser(isUserLoggedIn);
          getFields();
          getUnits();
        }
      },[isUserLoggedIn])


  useEffect(()=>{
    if(token && token !== undefined && token !== 'undefined' && token !== 'remove') {
      getFields();
      getUnits();
    }
  },[token])

  useEffect(()=>{
    clarity.init('tg33xes7os');
  },[])



  const { t, i18n } = useTranslation();
  document.body.dir = i18n.dir();
  return <UserContext.Provider value={{ 
    setIsUserLoggedIn: setIsUserLoggedIn,
    fields: fields,
    mainFieldsOptions: mainFieldsOptions,
    InventoryCategoriesOptions: InventoryCategoriesOptions,
    AssetsStatusOptions: AssetsStatusOptions,
    AssetTypeOptions: AssetTypeOptions,
    units: units,
    unitsOptions: unitsOptions,
    businessPackage: businessPackage,
    setBusinessPackage: setBusinessPackage  }}><ToastProvider><RouterProvider router={router} /><ToastContainer /></ToastProvider></UserContext.Provider>;
};

export default App;
